module.exports = __webpack_public_path__ + "img/nutsAndSticks.8eb60bcb.png";